<template>
  <div class="pa-6">
    <!-- Breadcrumb + Back -->
    <v-row class="align-center mb-4">
      <v-col cols="12" md="10">
        <Breadcrump :crumbs="crumbs" />
      </v-col>
      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn @click="$router.go(-1)" fab small dark color="#1976d2">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Card -->
    <v-card class="pa-4 elevation-3">
      <v-card-title class="title-font">
        ضریب‌دهی گزارش
      </v-card-title>

      <v-row class="mt-3">
        <!-- Multiplier -->
        <v-col cols="12" md="3">
          <v-text-field
            v-model="multiplier"
            label="ضریب"
            type="number"
            outlined
            dense
          />
        </v-col>

        <!-- From -->
        <v-col cols="12" md="4">
          <date-picker v-model="from" placeholder="از تاریخ" simple editable />
        </v-col>

        <!-- To -->
        <v-col cols="12" md="4">
          <date-picker v-model="to" placeholder="تا تاریخ" simple editable />
        </v-col>

        <!-- Submit -->
        <v-col cols="12" md="3">
          <v-btn
            color="#1976d2"
            class="white--text"
            :loading="loading"
            @click="submit"
          >
            اعمال ضریب
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Confirm Dialog -->
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="title-font">
          تایید عملیات
        </v-card-title>

        <v-card-text>
          آیا از اعمال ضریب مطمئن هستید؟
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="confirmDialog = false">
            انصراف
          </v-btn>
          <v-btn color="primary" text @click="confirmSubmit">
            تایید
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import moment from "moment-jalaali";
import Vue from "vue";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default {
  name: "DeviceReportMultiplier",
  components: { Breadcrump },

  data() {
    const today = moment().format("jYYYY/jMM/jDD");

    return {
      multiplier: null,
      from: today,
      to: today,
      loading: false,
      confirmDialog: false,
      deviceId: 0,

      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "مجموعه ها", disabled: false, href: "/complexes" },
        {
          text: `مجموعه ${this.$store.state.selectedComplexName || ""}`,
          disabled: false,
          href: `/complex-units/${this.$store.state.selectedComplexId}`
        },
        {
          text: this.$store.state.selectedDeviceName || "دستگاه",
          href: `/complex-devices/${this.$store.state.selectedComplexId}`,
          disabled: false
        },
        { text: "ضریب‌دهی گزارش", disabled: true }
      ]
    };
  },

  created() {
    this.deviceId = parseInt(this.$route.params.id);
  },

  methods: {
    submit() {
      this.confirmDialog = true;
    },

    confirmSubmit() {
      this.confirmDialog = false;
      this.loading = true;

      const payload = {
        multiplier: this.multiplier,
        from: moment(this.from, "jYYYY/jMM/jDD").format("YYYY-MM-DD"),
        to: moment(this.to, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
      };

      request
        .put(`/device/report-multiply/${this.deviceId}`, payload)
        .then(() => {
          Vue.swal("", "ضریب‌دهی گزارش با موفقیت انجام شد", "success");
        });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.pa-6 {
  padding: 20px;
  background: #f9fbfd;
  min-height: 100vh;
}

.title-font {
  font-family: "IranSans", sans-serif;
  font-weight: 600;
}

.v-card {
  border-radius: 16px;
}
</style>
